module.exports = __webpack_public_path__ + "static/media/plus-cereja.b0662e97.jpg";